import React from 'react';
import { Datagrid, DateField, TextField, BooleanField } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import UserReferenceField from './UserReferenceField';
import OrganizationReferenceField from '../organizations/OrganizationReferenceField';

import rowStyle from '../components/rowStyle';

const useListStyles = makeStyles({
    headerRow: {
        borderLeftColor: 'white',
        borderLeftWidth: 5,
        borderLeftStyle: 'solid',
    },
    comment: {
        maxWidth: '18em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});

const AlbaranListDesktop = ({ permissions, ...props }) => {
    const classes = useListStyles();
    
    return (
        <Datagrid
            rowClick="edit"
            rowStyle={rowStyle}
            classes={{ headerRow: classes.headerRow }}
            optimized
            {...props}
        >
            <DateField source="createdAt" />
            <UserReferenceField link={false} />
            <TextField source="ot" />
            <TextField source="description" />
            <OrganizationReferenceField source="organization._id" link={false} />
            <BooleanField source="checked" />
        </Datagrid>
    );
};

export default AlbaranListDesktop;
